import React from 'react';
import PropTypes from 'prop-types';

import { Col, Row, ControlLabel, FormGroup, FormControl } from 'react-bootstrap';
import ManagedInput from 'components/form/managed_input';

import { getLocation } from 'helpers/location_helper';

const LocationForm = ({ location, stateOptions, onLocationChange }) => {
  const { city, state, zip } = location;

  const handleEditLocationField = (value, key) => {
    onLocationChange({
      ...location,
      [key]: value
    });
  };

  const handleZipChange = (zip) => {
    onLocationChange({
      ...location,
      zip: zip.replace(/\D/g, '')
    });

    if (zip.length === 5) {
      getLocation(zip).then((locationData) => {
        const { city, state } = locationData;
        if (city && state) {
          onLocationChange({
            city,
            state,
            zip
          });
        }
      });
    }
  };

  return (
    <FormGroup>
      <Row>
        <Col md={6} sm={12}>
          <ControlLabel>City</ControlLabel>
          <ManagedInput
            className="form-control mb-4"
            name="city"
            placeholder="City"
            value={city}
            onValueChange={value => handleEditLocationField(value, 'city')}
          />

          <ControlLabel>State</ControlLabel>
          <FormControl
            className="mb-4"
            componentClass="select"
            name="state"
            placeholder="select"
            value={state}
            onChange={e => handleEditLocationField(e.target.value, 'state')}
          >
            <option value="">--</option>
            {stateOptions.map(({ value, label }) => <option key={value} value={value || ''}>{label}</option>)}
          </FormControl>

          <ControlLabel>Zip</ControlLabel>
          <ManagedInput
            className="form-control"
            name="zip"
            placeholder="Zip"
            value={zip}
            onValueChange={newZip => handleZipChange(newZip)}
          />
        </Col>
      </Row>
    </FormGroup>
  );
};

LocationForm.propTypes = {
  location: PropTypes.object.isRequired,
  stateOptions: PropTypes.array.isRequired,
  onLocationChange: PropTypes.func.isRequired
};

export default LocationForm;
